export const CANVAS_IDS = {
  LAYER_ID: "canvas-primary-layer-id",
  TRANSFORMER_ID: "canvas-primary-transformer-id",
  TEXT_GROUP_ID: "canvas-text-group-id",
  TEXT_WRAPPER_ID: "canvas-text-group-wrapper-id",
  LABEL_GROUP: "LABEL_GROUP",
  LABEL_ANCHOR: {
    TOP: "LABEL_ANCHOR_TOP",
    RIGHT: "LABEL_ANCHOR_RIGHT",
    BOTTOM: "LABEL_ANCHOR_BOTTOM",
    LEFT: "LABEL_ANCHOR_LEFT",
  },
  LABEL_ARROW: "LABEL_ARROW",
  ARROW_TRANSFORMER: "ARROW_POINTERTRANSFORMER",
};

export const KONVA_EVENTS = {
  MOUSEUP: "mouseup touchend",
  MOUSEMOVE: "mousemove touchmove",
  MOUSEDOWN: "mousedown touchstart",
  MOUSEOVER: "mouseover",
  MOUSEOUT: "mouseout",
  DRAGSTART: "dragstart",
  DRAGENTER: "dragenter",
  DRAGMOVE: "dragmove",
  DRAGEND: "dragend",
  DRAGLEAVE: "dragleave",
  DRAGOVER: "dragover",
  DROP: "drop",
  CLICK: "click tap",
  TRANSFORM: "transform",
  TRANSFORMEND: "transformend",
  DOUBLECLICK: "dblclick dbltap",
  TRANSFORMERATTACHED: "transformerattached",
  TRANSFORMERDETACHED: "transformerdetached",
  ATTACHINPUT: "ATTACHINPUT",
};

export const KONVA_ATTR = {
  IS_DRAWING_POLYGON: "isDrawingPolygon",
  IS_CHANGING_TEXT: "isChangingText",
  DRAGGED_ITEM_ID: "draggedItemId",
  SELECTED_ITEM_ID: "selectedItemId",
  DROPZONE_TAGGED_ANSWER: "dropzoneTaggedAnswer",
  LABEL_ARROWS: "LABEL_ARROWS",
};

export const KONVA_ITEM_TYPE = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  ELLIPSE: "ELLIPSE",
  POLYGON: "POLYGON",
  RECTANGLE: "RECTANGLE",
  LABEL: "LABEL",
};
